module.exports = __webpack_public_path__ + "static/media/open-book.75938828.svg";